import React, { useContext, useLayoutEffect, useState } from 'react';
import { useLocation } from 'react-router';

import { ModalContext } from '@swf/components/StarsModal/Context';
import Body from '@swf/components/StarsModal/components/Body';
import StarsWizard from '@swf/components/StarsWizard/StarsWizard';
import type { PageData, PokerContext } from '@swf/core/types/Poker';
import { useIsMobileDevice } from '@swf/poker';

import Header from '../Modal/Header/Header';

import styles from './CreateTournament.scss';
import CreateTournamentBanner from './CreateTournamentBanner/CreateTournamentBanner';
import type { TournamentContextState } from './CreateTournamentContext/CreateTournamentContext';
import CreateTournamentContext from './CreateTournamentContext/CreateTournamentContext';
import CreateTournamentFlow from './CreateTournamentFlow';

interface LocationState extends PageData {
  clubId: number;
  fetchService: PokerContext['fetchService'];
}

const CreateTournament: React.FC = () => {
  const location = useLocation<LocationState>();
  const isMobileDevice = useIsMobileDevice(true);

  const [state, setState] = useState<TournamentContextState>({
    activePage: 0,
    clubs: location.state.clubs,
    clubId: location.state.clubId,
    isRecurrenceOpen: false,
    title: '',
    fetchService: location.state.fetchService
  });
  const { setStyle } = useContext(ModalContext);

  useLayoutEffect(() =>
    setStyle({ className: styles.createTournModal, closeOnOverlayClick: true, closeOnEsc: true })
  );

  return (
    <CreateTournamentContext.Provider value={{ state, setState }}>
      {!isMobileDevice && <CreateTournamentBanner />}
      <div className={styles.content}>
        <Header title={state.title} />
        <Body className={styles.body}>
          <StarsWizard flow={[CreateTournamentFlow]}>
            <CreateTournamentFlow />
          </StarsWizard>
        </Body>
      </div>
    </CreateTournamentContext.Provider>
  );
};

export default CreateTournament;
